import Box from '@mui/material/Box';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import type { PropsWithChildren } from 'react';

interface Props {
  severity: 'info' | 'success' | 'error' | 'warning' | 'other';
  style?: object;
}

export const Banner = ({
  children,
  severity,
  style = {},
}: PropsWithChildren<Props>) => {
  return (
    <Box className={banner} style={{ ...colors[severity], ...style }}>
      {children}
    </Box>
  );
};

const colors = {
  info: {
    borderColor: '#0F61AC33',
    backgroundColor: '#F0F6FF',
    color: '#0F61AC',
  },
  success: {
    borderColor: '#C0E3CC',
    backgroundColor: '#F0FFEF',
    color: '#027243',
  },
  warning: {
    borderColor: theme.palette.warning.border,
    backgroundColor: theme.palette.warning.warningContainer,
    color: theme.palette.warning.warning,
  },
  error: {
    borderColor: '#EEC7CA',
    backgroundColor: '#FFEFEF',
    color: '#AC2734',
  },
  other: {
    borderColor: '#F6F5FA',
    backgroundColor: '#F6F5FA',
    color: '#000000',
  },
};

const banner = css((theme) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: `${theme.spacing['2']}`,
  padding: `${theme.spacing['4']}`,
  border: 'solid',
  borderRadius: '8px',
  width: '50%',
}));
